import { useState, useEffect, createContext, useContext } from "react";
import * as React from "react";
import { addError } from "@wayflyer/blackbox-fe";

import { getDashboardOutput } from "../utils/fetch-api";

const CurrencyContext = createContext<{ currency: string } | null>(null);

export const useCurrency = (): string => {
  const ctx = useContext(CurrencyContext);
  if (!ctx) {
    throw new Error("useCurrency must be used within a CurrencyProvider");
  }
  return ctx.currency;
};

export const CurrencyProvider = ({ dashboardDataPath, children }) => {
  const [currency, setCurrency] = useState("");

  const fetchCurrency = React.useCallback(() => {
    if (dashboardDataPath) {
      getDashboardOutput(
        dashboardDataPath,
        [
          {
            metrics: [],
            filename: "overview_insights",
            groupBys: [],
          },
        ],
        { start: "", end: "" },
        (data) => {
          setCurrency(data.currencyCode);
        },
        null,
        (error) => {
          addError(error);
        },
        {
          resolution: "WEEKLY",
          label: "Weekly",
          duration: "week",
          startOf: "isoWeek",
          xAxisLabelFormat: "[Week] W (D MMM)",
        }
      );
    }
  }, [dashboardDataPath]);

  useEffect(() => {
    fetchCurrency();
  }, [fetchCurrency]);

  return <CurrencyContext.Provider value={{ currency }}>{children}</CurrencyContext.Provider>;
};
